import { ListItemIcon, ListItemText, Stack } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { getLogo } from 'components/scenarios/create/status-checks/third-party-presets'
import { type ObservabilityTool } from 'components/status-checks/authentication-form-utils'
import { LIST_ITEM_MIN_WIDTH } from 'components/status-checks/status-checks-form-utils'
import theme from 'theme'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const ObservabilityToolMenuItemLabel: React.FC<
  Pick<ObservabilityTool, 'integrationType' | 'name'>
> = ({ integrationType, name }) => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      // The fontSizes value is used here to match the height of the Icon/img components in the ListItemIcon. This is
      // used to prevent the Select textfield component from expanding and causing a misalignment of UI components.
      sx={{ maxHeight: theme.fontSizes[4] }}
    >
      <ListItemIcon sx={{ minWidth: LIST_ITEM_MIN_WIDTH }}>
        {integrationType === IntegrationType.Custom ? (
          <Icon
            css={{
              height: theme.fontSizes[4],
              width: theme.fontSizes[4]
            }}
            icon="regularTelescope"
          />
        ) : (
          <img
            alt={name}
            css={{
              color: theme.colors.gray[1],
              width: theme.fontSizes[4],
              height: theme.fontSizes[4]
            }}
            src={getLogo(integrationType)}
          />
        )}
      </ListItemIcon>
      <ListItemText>{name}</ListItemText>
    </Stack>
  )
}
